import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { History } from 'history';

import { receiveError } from '../../store/actions/notificationAction';
import { updateWholeTruckCart } from '../../store/actions/truckCartAction';
import { deleteExportAwbFromCart } from '../../store/actions/truckCartAction';

import cartRemote from '../../api/cartRemote';

import PrevNext from '../prevAndNext/PrevNext';
import TruckCart from './TruckCart';
import ProcessBarContainer from '../processBar/ProcessBarContainer';

import ApiResponse from '../../models/ApiResponse';
import ResponseError from '../../models/ResponseError';
import TruckCartModel from '../../models/TruckCart';
import { UserRoleType } from '../../models/User';

import truckCartStyles from './truckCart.module.css';
import { setWaitListId } from '../../store/actions/waitListAction';

interface TruckCartContainerState { 
  disableButton: boolean;
};

interface TruckCartContainerProps {
  history: History;
  truckCart: TruckCartModel;
  receiveError: (error: ResponseError) => void;
  updateWholeTruckCart: (truckCart: TruckCartModel) => void;
  deleteExportAwbFromCart: (awbCode: string, awbNumber: string) => void;
  userRole: UserRoleType;
  setWaitListId: (driverId: number) => void;
};
  
class TruckCartContainer extends Component <TruckCartContainerProps, TruckCartContainerState> {

  state: TruckCartContainerState= {
    disableButton: false
  }

  handleGenerateDropOffOrder = (): void => {
    if (this.state.disableButton) return;

    this.setState({ disableButton: true }, () => {
      cartRemote.generateDropOffOrder().then((resp: ApiResponse<TruckCartModel>) => {
      
        const truckCart: TruckCartModel | undefined = resp.result;
        const error: ResponseError | undefined = resp.error;
  
        if (truckCart) {
          this.props.setWaitListId(0);
          this.props.updateWholeTruckCart(truckCart);
          if (this.props.userRole === UserRoleType.FORWARDER) {
            this.props.history.push('/drop-off-order');
          } else {
            this.props.history.push('/manual-entry-drop-off-order');
          }
        };
  
        if (error) {
          this.props.receiveError(error);
          this.setState({ disableButton: false });
        };
      });
    });
  }

  render() {

    const truckCartItems: number = this.props.truckCart.cart.length;
    let renderItem: JSX.Element = <div className={ truckCartStyles.emptyCart }>No Drop Off AWBs selected!</div>;
    const prevButtonHref: string = this.props.userRole === UserRoleType.FORWARDER ?  '/my-exports' : '/manual-entry-export';
    const nextButtonHref: string = this.props.userRole === UserRoleType.FORWARDER ? '/drop-off-order' : '/manual-entry-drop-off-order';

    if (truckCartItems > 0) {
        renderItem = <div className={ truckCartStyles.truckCartWrapper } >
            <TruckCart
              truckCart={ this.props.truckCart }
              deleteExportAwbFromCart={ this.props.deleteExportAwbFromCart }
              handleGenerateDropOffOrder={ this.handleGenerateDropOffOrder }
              disableButton={ this.state.disableButton }
            />
          </div>;
    }

    return (
      <Fragment>
        <ProcessBarContainer type='export' userRole={ this.props.userRole} />
        { renderItem }
        <PrevNext prevButton={ { active: true, href:  `${prevButtonHref}`, animate: true } } nextButton={ { active: true, href:  `${nextButtonHref}`, animate: true } } />
      </Fragment>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    truckCart: state.truckCart
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    deleteExportAwbFromCart: (awbCode: string, awbNumber: string) => dispatch(deleteExportAwbFromCart(awbCode, awbNumber)),
    receiveError: (error: ResponseError) => dispatch(receiveError(error)),
    updateWholeTruckCart: (cart: TruckCartModel) => dispatch(updateWholeTruckCart(cart)),
    setWaitListId: (driverId: number) => dispatch(setWaitListId(driverId))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TruckCartContainer);